// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as CryptoJS from 'crypto-js';

let cv = '';

function generateRandomString(length) {
  let text = '';
  const codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}
export const environment = {
  envName: 'dev',
  production: false,
  authBucket:'access-auth',
  searchGridUrl:'https://dev.searchgrids.ebom.toyota.com/',
  //redirectUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=fb94a15a-86f3-4fcf-8889-8f6090288f18&response_type=code&redirect_uri=http://localhost:4200&response_mode=query&scope=openid&state=23343&code_challenge=',
  redirectUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=fb94a15a-86f3-4fcf-8889-8f6090288f18&response_type=code&redirect_uri=https://devnew.ebom.toyota.com&response_mode=query&scope=openid&state=23343&code_challenge=',
  apiUrl: "http://localhost:8080/ebom",
  MastergridapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  MastersearchdropdownapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown1apiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown2apiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown3apiUrlrest1: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown3apiUrlrest2: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  BussinessgridapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapi1Url: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  BusinesssearchdropdownapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  Business_Qe_dropdownapiURL: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_1',
  Master_ActionapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_1',
  Master_EditapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  Master_ActionInsertApiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_1',
  // BusinessManAdjstapiUrl: 'https://6gr5m8y0u3.execute-api.us-east-1.amazonaws.com/dev/api',
  BussinessppsvapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionRestapiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionS2apiUrl: 'https://api.devnew.ebom.toyota.com/ebom_common_rest_2',
  Uploadrest: ' https://api.devnew.ebom.toyota.com/ebom_common_rest_3',
  NewURL : 'https://api.devnew.ebom.toyota.com/dev_master_insert',
  workdayId: "extensionAttribute3",
  region: 'us-west-2',
  // uploadBucketName: 'ebom.fileupload',
  uploadBucketName: 'ebom.upload.dev',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  rmvUserDetailsUrl:'https://th4huac7nb.execute-api.us-west-2.amazonaws.com/dev/api/',
  tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  grantType: 'authorization_code',
   hostname:'devnew.ebom.toyota.com',
  clientId: 'fb94a15a-86f3-4fcf-8889-8f6090288f18',
 // redirectURI: 'http://localhost:4200/',
  redirectURI: 'https://devnew.ebom.toyota.com',
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
